// extracted by extract-css-chunks-webpack-plugin
module.exports = {"section":"help-modal__section___3t2mh","text":"help-modal__text___2TVLP","header":"help-modal__header___ti4X5","link":"help-modal__link___3h2mD","link-item":"help-modal__link-item___3Mdhf","linkItem":"help-modal__link-item___3Mdhf","link-icon":"help-modal__link-icon___AWOAZ","linkIcon":"help-modal__link-icon___AWOAZ","details":"help-modal__details___fKoY9"};
    if(module.hot) {
      // 1744775390521
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  